import React, { Component } from "react";
import Form, { formTypes } from "../../Forms/Containers/FormCreator";

class MassiveLoadComponent extends Component {
  render() {
    return (
      <Form
        onChange={this.props.onChange}
        objectCreator={[          
          {
            type: formTypes.calendar,
            classContainer: "line line-50",
            classLabel: "input-text",
            label: "Fecha de corte de los datos",
            placeholder: "Ingrese su(s) nombre(s)",
            required: true,
            variable: "cutDate"
            // value: '',
          },
          {
            type: formTypes.select,
            classContainer: "line line-50",
            // classInput: "form-control",
            classLabel: "input-text",
            label: "Forma de carga",
            placeholder: "Seleccione opción",
            required: true,
            variable: "type",
            data: [
              { text: "incremental", id: 1 },
              { text: "Total del año", id: 2 }
            ],
            keyValue: "id",
            keyText: "text",
            value: [],
          },
          {
            type: formTypes.select,
            classContainer: "line line-50",
            // classInput: "form-control",
            classLabel: "input-text",
            label: "Fuente",
            placeholder: "Seleccione opción",
            required: true,
            variable: "source",
            data: [
              { text: "SIEDCO", id: 1 },
              { text: "SECAD", id: 2 },
              { text: "CAPTURAS SIEDCO", id: 3 },
            ],
            keyValue: "id",
            keyText: "text",
            value: [],
          },
          {
            type: formTypes.attach,
            classContainer: "line line-50",
            // classInput: "form-control",
            classLabel: "input-text",
            label: "Adjuntar archivo Excel",
            placeholder: "Ingrese por favor el barrio del hecho",
            required: true,
            btnLabel: "Seleccionar archivo",
            variable: "xlsFile"
            // value: '',
          },
          {
            type: formTypes.div,
            classContainer: "line line-100"
          },
          {
            type: formTypes.div,
            classContainer: "line line-33"
          },
          {
            type: formTypes.submit,
            classContainer: "button-primary line line-33 text-center",
            label: "Enviar",
            placeholder: "-"
          },
        ]}
        values={this.props.values}
        onSubmit={this.props.onSubmit}
      />
    );
  }
}

export default MassiveLoadComponent;
